import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { validators } from '../config/security'
import { solicitarRecuperacaoSenha } from '../services/passwordReset'
import './Auth.css'

const EsqueciSenha = () => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [sent, setSent] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    const normalized = email.trim().toLowerCase()
    if (!normalized) {
      setError('E-mail é obrigatório')
      return
    }
    if (!validators.isValidEmail(normalized)) {
      setError('E-mail inválido')
      return
    }

    setLoading(true)
    const result = await solicitarRecuperacaoSenha(normalized)
    setLoading(false)

    if (!result.success) {
      setError(result.error || 'Não foi possível enviar o e-mail.')
      return
    }

    setSuccessMessage(result.message)
    setSent(true)
  }

  return (
    <div className="auth-page">
      <div className="auth-glass-card">
        <Link to="/login" className="auth-back-link">
          <svg xmlns="http://www.w3.org/2000/svg" className="auth-back-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Voltar para o login
        </Link>

        <div className="auth-header-block auth-header-block-left">
          <h1 className="auth-page-title">Recuperar senha</h1>
          <p className="auth-subtitle auth-subtitle-left">
            Insira o e-mail associado à sua conta e enviaremos as instruções para redefinir sua senha.
          </p>
        </div>

        {error && (
          <div className="auth-alert auth-alert-error" role="alert">
            {error}
          </div>
        )}

        {!sent ? (
          <form onSubmit={handleSubmit} className="auth-form-modern">
            <div className="auth-field">
              <label htmlFor="email-recovery" className="auth-label">
                E-mail cadastrado
              </label>
              <input
                type="email"
                id="email-recovery"
                className="auth-input"
                value={email}
                onChange={(e) => setEmail(e.target.value.toLowerCase())}
                placeholder="exemplo@email.com"
                required
                disabled={loading}
                autoComplete="email"
              />
            </div>

            <button type="submit" className="auth-btn-primary" disabled={loading}>
              {loading ? 'ENVIANDO...' : 'ENVIAR LINK DE REDEFINIÇÃO'}
            </button>
          </form>
        ) : (
          <div className="auth-success-box" role="status">
            <svg className="auth-success-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <div>
              <h3 className="auth-success-title">E-mail enviado!</h3>
              <p className="auth-success-text">{successMessage}</p>
              <p className="auth-success-hint">Verifique sua caixa de entrada em instantes.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default EsqueciSenha
